import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

import cart_image from '../../assets/images/icons/cart.png'
import unlock from '../../assets/images/icons/unlock.png'
import birthday from '../../assets/images/icons/birthday.png'

export interface BenefitImageProps {
  imageName?: string
  hideBottomImage?: boolean
}

// prevent custom props from reaching DOM
const shouldForward = (prop: PropertyKey) => prop !== 'imageName' && prop !== 'hideBottomImage'

export const BenefitSubtext = styled('p')(() => ({
  textAlign: 'left',
  padding: 0,
  paddingLeft: 70,
  margin: '0 0 20px',
}))

export const BenefitIcon = styled('span', { shouldForwardProp: shouldForward })<BenefitImageProps>(
  ({ imageName }) => {
    let bg: string | undefined
    switch (imageName) {
      case 'save-more':
        bg = unlock
        break
      case 'faster-checkout':
        bg = cart_image
        break
      case 'birthday-reward':
        bg = birthday
        break
      default:
        bg = undefined
    }

    return {
      display: 'inline-block',
      width: 65,
      height: 65,
      maxHeight: 65,
      maxWidth: 65,
      marginRight: 5,
      position: 'relative',
      top: 45,
      ...(bg
        ? {
            backgroundImage: `url(${bg})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
          }
        : {}),
    }
  }
)

export const BenefitTitle = styled('h5')(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  margin: '0 0 10px 0',
  '@media only screen and (max-width: 720px)': {
    fontSize: 20,
  },
}))

export const BenefitInfoContainer = styled('div')(() => ({
  width: 250,
  height: 150,
  '@media only screen and (max-width: 1368px)': {
    maxWidth: '90%',
    width: '90%',
  },
}))

export const BenefitContainer = styled('div')(() => ({
  minWidth: 250,
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  '@media only screen and (min-width: 768px)': {
    maxWidth: '50%',
  },
  '@media only screen and (min-width: 992px)': {
    maxWidth: '33%',
    flexDirection: 'column',
  },
  '@media only screen and (max-width: 768px)': {
    width: '100%',
    display: 'block',
    position: 'relative',
    top: -17,
  },
}))

export const BenefitsWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  '@media only screen and (min-width: 576px)': {
    flexDirection: 'row',
  },
}))
